import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { statusConfig } from '../config/status-config';

/**
 * campaign item component for the adgroup selector
 */
export class CampaignItemComponent extends PureComponent {
  render() {
    return (
      <div className={classnames('multi-item-container', 'item-content')}>
        <span className={classnames('statusIcon', _.result(statusConfig, this.props.item.status, 'statusEnabled_icon'))} />
        <span className="text" title={this.props.item.name}>
          {this.props.item.name}
        </span>
      </div>
    );
  }
}

CampaignItemComponent.propTypes = {
  item: PropTypes.shape({
    /**
     * campaign status
     */
    status: PropTypes.string.isRequired,
    /**
     * campaign name
     */
    name: PropTypes.string.isRequired,
  }).isRequired,
};
